import React, { FC, useEffect, useState } from "react";
import { LayoutProps } from "./Layout.props";
import Navbar from "@components/Navbar/Navbar";
import Footer from "@components/Footer/Footer";
import MobileNavbar from "@components/Navbar/MobileNavbar";

const Layout: FC<LayoutProps> = ({ children }) => {
	// Determine if it's mobile (using 1024px as the breakpoint).
	const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 1024);

	useEffect(() => {
		const handleResize = () => setIsMobile(window.innerWidth <= 1024);

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return (
		<div className="flex flex-col min-h-screen bg-bgColor">
			{/* Only render Navbar if not on the chat route */}
			{isMobile ? <MobileNavbar /> : <Navbar />}

			<div className="flex-1">{children}</div>

			{/* Only render Footer if not on the chat route */}
			<Footer />
		</div>
	);
};

export default Layout;
